import $ from 'jquery';
import _ from 'lodash';
import ko from '@tko/build.knockout';
import '../../thirdPartyForks/bootstrap-tokenfield';

ko.tokenfield = {};

ko.bindingHandlers['tokenField'] = {

    init: function (element, valueAccessor, allBindingsAccessor, deprecated, bindingContext) {

        if (!element.id) {
            var id = new Date().getTime() + '' + Math.floor((1 + Math.random()) * 100);
            element.id = id;
        }

        var observable = valueAccessor() || {};

        var allBindings = allBindingsAccessor();
        var allowUserTokens = allBindings.allowUserTokens;

        ko.tokenfield[element.id] = {};

        ko.tokenfield[element.id].handlerEnabled = true;

        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
            $(element).tokenfield('destroy');
        });

       ko.utils.registerEventHandler(element, 'tokenfield:createtoken', function (e) {

           if (ko.tokenfield[element.id].handlerEnabled === false)
               return true;

           if (!allowUserTokens)
               return false;

           e.attrs.label = $.trim(e.attrs.label.replace(/(\s|\,)/g, ''));
           e.attrs.value = e.attrs.label;

           if (!e.attrs.value)
               return false;
           var dup = $.grep(observable(), function (item) { return (item.value.toLowerCase() === e.attrs.value.toLowerCase()); });
           return (dup.length <= 0);

       });


        ko.utils.registerEventHandler(element, 'tokenfield:createdtoken', function (e) {
            if (ko.tokenfield[element.id].handlerEnabled === true) {
                ko.tokenfield[element.id].handlerEnabled = false;
                observable.push(e.attrs);
                ko.tokenfield[element.id].handlerEnabled = true;
            }
        });

        ko.utils.registerEventHandler(element, 'tokenfield:removedtoken', function (e) {
            var peeked = observable.peek();
            var item;
            // Find item using tokenfield default values, other values are not in tokenfield meta-data.
            ko.utils.arrayForEach(peeked, function (x) {

                var valueToCompare = x.desc ? ko.unwrap(x.desc) : ko.unwrap(x.label);

                if ((!_.isEmpty(e.attrs.value) && valueToCompare === e.attrs.value)) {
                    item = x;
                }

            });
            ko.tokenfield[element.id].handlerEnabled = false;
            observable.remove(item);
            ko.tokenfield[element.id].handlerEnabled = true;
        });

        $(element).tokenfield({
            createTokensOnBlur: true,
            allowEditing: false,
            // See http://http://sliptree.github.io/bootstrap-tokenfield/ for a list of available options
        });
    },

    /**
     * ko binding update
     */
    update: function (element, valueAccessor, allBindingsAccessor, deprecated, bindingContext) {
        //NOTE: the following line is required for update to fire
        ko.unwrap(valueAccessor());

        if (ko.tokenfield[element.id].handlerEnabled === false)
            return;

        var observable = valueAccessor() || {};
        var peeked = ko.unwrap(observable.peek());

        ko.tokenfield[element.id].handlerEnabled = false;

        //TODO: see if setTokens is sufficient to avoid createToken events and associated flags
        //Optional loop through, set tokens and adjust values.
        $(element).tokenfield('setTokens',[]);
        if (peeked.length > 0) {
            $.each(peeked, function(index, value) {
                $(element).tokenfield('createToken', value.desc || value.label);
            });
        }
        ko.tokenfield[element.id].handlerEnabled = true;
    }
};
